module.exports = __webpack_public_path__ + "img/landing_box49.9755957b.jpg";